import MenuHeader from "../../common/MenuHeader"
import RightGoogleMap from "../../common/RightGoogleMap"
import SetUpLayout from "../../common/SetUpLayout"
import LayoutMain from "./LayoutMain"

type Props = {}

const StationAssignment = (props: Props) => {
  return (
    <SetUpLayout
      title='Station Assignment'
      header={
        <MenuHeader />
      }
      rightLayout={<RightGoogleMap style={{
        width: { xs: '488px' },
      }}
      />}
    >
      <LayoutMain />
    </SetUpLayout>
  )
}

export default StationAssignment